<template>
<div class="feedback-container" >
  <div class="feedback-title" >
    Selon vous, doit-on ajouter ces compétences à l'offre de formation existante sur le territoire ?
  </div>
  <div class="feedback-row" >
    <div class="feedback-graph" >
      <horizontal-bar v-bind="graphProps" ref="graph" />
    </div>
    <div v-if="feedbacks.length" class="feedback-feedback" :style="extraStyle" >
      <div class="header" :style="{ height: `${marginTop}px` }" >
        <div v-for="key in Object.keys(feedbackValues).slice(0, 3)" :key="key" >
          {{ feedbackValues[key].title }}
          <el-popover
            v-if="feedbackValues[key].help"
            placement="left"
            trigger="hover"
            :content="feedbackValues[key].help" >
            <i slot="reference" class="handle el-icon-question" />
          </el-popover>
        </div>
      </div>
      <el-radio-group
        v-for="feedback in feedbacks"
        v-model="feedback.feedback"
        @change="() => handleChange(feedback)"
        :key="feedback.data.id"
        :style="extraEntryStyle"
        :data-tmp="feedback.feedback"
        class="feedback-entry" >
        <el-radio
          v-for="key in Object.keys(feedbackValues).slice(0, 3)"
          :label="feedbackValues[key].title"
          :value="key"
          :key="key" />
      </el-radio-group>
    </div>
  </div>
</div>
</template>

<script>
import HorizontalBar from 'd3vue/components/HorizontalBar.vue'
import crypto from 'crypto'

export default {
  components: {
    HorizontalBar
  },
  data () {
    return {
      feedbacks: []
    }
  },
  props: {
    feedbackRatio: {
      type: Number,
      default: 0.33
    },
    feedbackValues: {
      type: Object,
      default: () => {
        return {
          1: { title: 'Nouveau, à ajouter ?' },
          2: { title: 'Oui, mais déjà là ?' },
          3: { title: 'Non, pas pertinent ?' }
        }
      }
    }
  },
  mounted () {
    this.$watch(
      () => {
        if (!this.$refs.graph) {
          return []
        }
        return this.$refs.graph.leaves
      },
      data => {
        this.feedbacks.splice(0, this.feedbacks.length, ...data.map(d => {
          return {
            data: d,
            feedback: this.getFeedback(d)
          }
        }))
      },
      { immediate: true }
    )
  },
  computed: {
    marginTop () {
      return this.$attrs.marginTop || this.$attrs['margin-top'] || 40
    },
    marginBottom () {
      return this.$attrs.marginBottom || this.$attrs['margin-bottom'] || 40
    },
    height () {
      return this.$attrs.height - this.marginTop - this.marginBottom - 19
    },
    extraStyle () {
      return {
        'height': `${this.height}px`,
        'padding-top': `${this.$attrs.marginTop || this.$attrs['margin-top'] || 40}px`,
        'padding-bottom': `${this.marginBottom + 5}px`
      }
    },
    extraEntryStyle () {
      return {
        'height': `${this.height / this.feedbacks.length}px`
      }
    },
    graphProps () {
      return Object.assign({}, this.$attrs, {
        width: this.$attrs.width * (1 - this.feedbackRatio),
        height: this.$attrs.height - 19
      })
    }
  },
  methods: {
    getFeedback (data) {
      return this.$store.state.chloe.feedbacks[this.getHash(data.id)] || null
    },
    getHash (id) {
      const filters = this.$store.state.chloe.globalFilters.map(f => f).sort()
      filters.push(id)
      return crypto.createHash('sha1').update(filters.join('#')).digest('hex')
    },
    getKey (feedback) {
      return Object.keys(this.feedbackValues).map(key => {
        return { key: key, value: this.feedbackValues[key].title }
      }).find(item => item.value === feedback.feedback).key
    },
    handleChange (feedback) {
      this.$store.commit('setFeedback', {
        key: this.getHash(feedback.data.id),
        feedback: feedback.feedback
      })
      Promise.all(this.$store.state.chloe.globalFilters.map(filter => {
        return this
          .$store
          .dispatch('customGraph/loadValues', filter.split('].&[').slice(0, 1) + ']')
          .then(values => {
            return values.find(v => v.uniqueName === filter)
          })
      })).then(filters => {
        this.$store.dispatch('track', {
          action: 'skill-feedback',
          data: {
            trade: filters[0],
            fap87: filters[1],
            fap: filters[2],
            ze: filters[3],
            region: filters[4],
            department: filters[5],
            filters: this.$store.state.chloe.globalFilters,
            value: feedback.feedback,
            id: this.getKey(feedback),
            skill: {
              id: feedback.data.key,
              label: feedback.data.label
            }
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.feedback-row {
    display: flex;
}
.feedback-title {
    margin-bottom: 10px;
    height: 9px;
    line-height: 9px;
}
.feedback-feedback {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    position: relative;
    flex: 1;
}
.feedback-feedback .header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
}
.feedback-feedback .header div {
    width: 33%;
    max-width: 33%;
}
.feedback-entry {
    display: flex;
}
.feedback-entry label {
    width: 33%;
    max-width: 33%;
}
.feedback-entry >>> .el-radio__label {
    display: none;
}
.feedback-entry >>> .el-radio__inner {
    border-color: #868686;
}
.feedback-entry >>> .el-radio {
    margin-top: auto;
    margin-bottom: auto;
}
</style>



// WEBPACK FOOTER //
// src/graphs/Feedback.vue